import { ENDPOINT } from '@shopee-mmc/endpoint-sdk';
import "./CdnPicture.modules.css";
import { MmsEnv, MmsCid } from './constants';
export function isImagePath(url) {
  var reg = /^https?:\/\//;
  return reg.test(url) || url.startsWith('/') || url.startsWith('data:');
}
export var getMmsPath = function getMmsPath(biz, imageId, suffix) {
  var endpoint = new ENDPOINT({
    biz: biz,
    country: MmsCid,
    env: MmsEnv
  }); // get image url(https)

  var path = endpoint.getImgHttpsUrlV2(biz, imageId, suffix);

  if (path.ok) {
    return path.url;
  } // FIXME: 不ok时的处理


  return imageId;
};